import request from "@/api";

//获取当前用户信息-GetCurrentUserInfo
export function GetCurrentUserInfoApi(data){
    return request({
        url:'',
        method:'post',
        data:data,
    })
}

//登入第一步-GetUserLoginInfo
export function GetUserLoginInfoApi(data){
    return request({
        url:'',
        method:'post',
        data:data,
    })
}

//登入第二步-UserLogin
export function UserLoginApi(data){
    return request({
        url:'',
        method:'post',
        data:data,
    })
}

//獲取座、樓層、單位-CSGetBuildingUnitFloor
export function CSGetBuildingUnitFloorApi(data){
    return request({
        url:'',
        method:'post',
        data:data,
    })
}

//【文件】獲取單位文件夾列表-CSBMGetFileDirs
export function CSBMGetFileDirsApi(data){
    return request({
        url:'',
        method:'post',
        data:data,
    })
}

//【文件】獲取指定文件列表-CSBMGetFileList
export function CSBMGetFileListApi(data){
    return request({
        url:'',
        method:'post',
        data:data,
    })
}

//【文件】獲取文件更新記錄-CSBMGetFileUpdateRecord
export function CSBMGetFileUpdateRecordApi(data){
    return request({
        url:'',
        method:'post',
        data:data,
    })
}

//【文件】根據記錄ID獲取詳情-CSBMGetFileUpdateDetail
export function CSBMGetFileUpdateDetailApi(data){
    return request({
        url:'',
        method:'post',
        data:data,
    })
}

//【文件】上傳文件-ReportRepairUserUploadFile
export function ReportRepairUserUploadFileApi(data){
    return request({
        url:'',
        method:'post',
        data:data,
    })
}

//【文件】上傳文件-UserUploadFile
export function UserUploadFileApi(data){
    return request({
        url:'',
        method:'post',
        data:data,
    })
}

//【文件】提交添加文件列表-CSBMPostFileList
export function CSBMPostFileListApi(data){
    return request({
        url:'',
        method:'post',
        data:data,
    })
}

//修改密码-EditPassword
export function EditPasswordApi(data){
    return request({
        url:'',
        method:'post',
        data:data,
    })
}

//忘记密码-LostLoginPassword
export function LostLoginPasswordApi(data){
    return request({
        url:'',
        method:'post',
        data:data,
    })
}



// WEBPACK FOOTER //
// ./src/api/user.js